import React from 'react'

export const FeierUndEvents = () => {
    return (
        <div class="randBox">

<ul className="list-group list-group-flush">
    <h2 className="list-group-item">Feiern & Events auf dem Alpakahof</h2>
    <p className="mx-4">
        Ob Geburtstag, Familienfeier oder ein besonderes Teamevent – unser Alpakahof bietet den perfekten Ort für unvergessliche Momente inmitten der Natur.
    </p>
    
    <h4 className="list-group-item">Ein besonderes Erlebnis für Groß und Klein</h4>
    <p className="mx-4">
    Unsere sanftmütigen Alpakas schaffen eine ganz besondere Atmosphäre, die jede Feier zu einem entspannten und gleichzeitig außergewöhnlichen Erlebnis macht. <br />
    Gemeinsam mit den Tieren spazieren gehen, sie beobachten, streicheln oder einfach die Ruhe auf der Weide genießen – bei uns steht das Naturerlebnis im Mittelpunkt.
    </p>

    <h4 className="list-group-item">Eure Feier, ganz individuell</h4>
    <p className="mx-4">
        Ob ihr eine rustikale Kaffeetafel mit Blick auf die Alpakawiese plant oder ein buntes Kinderprogramm mit Stallbesuch und kleiner Schatzsuche – wir gestalten euer Event ganz nach euren Wünschen.
        Gerne stellen wir Sitzgelegenheiten, wetterabhängig überdachte Bereiche sowie auf Wunsch auch Getränke bereit.
    </p>

    <h4 className="list-group-item">Beliebte Anlässe</h4>
    <p className="mx-4">
        <li>Kindergeburtstage</li>
        <li>Familienfeiern</li>
        <li>Teamevents & Betriebsausflüge</li>
        <li>Ruhige Naturauszeiten mit Freundinnen und Freunden</li>
    </p>

    <h4 className="list-group-item"> Gut zu wissen</h4>
    <p className="mx-4">
        <li>Eigene Speisen und Getränke dürfen mitgebracht werden</li>
        <li>Toiletten stehen kostenfrei zur Verfügung</li>
        <li>Bei Bedarf helfen wir gerne bei der Organisation</li>
        <li>Termine nach Vereinbarung</li>
        <li>Preise individuell nach Gruppengröße und Wunschprogramm</li>
    </p>
</ul>

  

  <p><strong>Bitte meldet euch telefonisch bei uns</strong>, um einen Termin zu vereinbaren oder mehr über die Gestaltungsmöglichkeiten zu erfahren. Wir freuen uns auf euren Anruf!</p>
</div>

    )
}